/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Info_Rule_Per_HandInputs */

const en_us2_exercise_personal_info_rule_per_hand = /** @type {(inputs: Exercise_Personal_Info_Rule_Per_HandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With dumbbells, it is the weight of one dumbbell, not both together.`)
};

const pt_br2_exercise_personal_info_rule_per_hand = /** @type {(inputs: Exercise_Personal_Info_Rule_Per_HandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com halteres, vale o peso de um halter, não a soma dos dois.`)
};

const es_419_exercise_personal_info_rule_per_hand = /** @type {(inputs: Exercise_Personal_Info_Rule_Per_HandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con mancuernas, cuenta el peso de una mancuerna, no la suma de las dos.`)
};

const pt_pt2_exercise_personal_info_rule_per_hand = /** @type {(inputs: Exercise_Personal_Info_Rule_Per_HandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com halteres, conta o peso de um haltere, não a soma dos dois.`)
};

const fr_fr2_exercise_personal_info_rule_per_hand = /** @type {(inputs: Exercise_Personal_Info_Rule_Per_HandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avec des haltères, c'est le poids d'un seul haltère, pas des deux ensemble.`)
};

const de_de2_exercise_personal_info_rule_per_hand = /** @type {(inputs: Exercise_Personal_Info_Rule_Per_HandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei Kurzhanteln zählt das Gewicht einer Hantel, nicht beider zusammen.`)
};

const it_it2_exercise_personal_info_rule_per_hand = /** @type {(inputs: Exercise_Personal_Info_Rule_Per_HandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con i manubri conta il peso di un manubrio, non dei due insieme.`)
};

/**
* | output |
* | --- |
* | "With dumbbells, it is the weight of one dumbbell, not both together." |
*
* @param {Exercise_Personal_Info_Rule_Per_HandInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_info_rule_per_hand = /** @type {((inputs?: Exercise_Personal_Info_Rule_Per_HandInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Info_Rule_Per_HandInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_info_rule_per_hand(inputs)
	if (locale === "es-419") return es_419_exercise_personal_info_rule_per_hand(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_info_rule_per_hand(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_info_rule_per_hand(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_info_rule_per_hand(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_info_rule_per_hand(inputs)
	return en_us2_exercise_personal_info_rule_per_hand(inputs)
});
export { exercise_personal_info_rule_per_hand as "exercise-personal.info_rule_per_hand" }